export default "__VITE_ASSET__ByBU_dRR__"